import { detectPartitionCookieSupport } from 'js/lib/partitionCookieDetect';

import { resolveEmbeddedLaunchContext } from './embeddedLaunchContext';

/*
 * Whether this page was launched from an LMS embed, regardless of whether the
 * embedded experience is enabled. Use `isEmbeddedExperience` to check whether
 * the embedded UI should actually render.
 */
export const isEmbeddedLaunch = (): boolean => resolveEmbeddedLaunchContext().embedScope != null;

/*
 * Whether the simplified embedded experience is active. True only for
 * org-enabled LTI launches running in an iframe with usable CHIPS cookies.
 */
export const isEmbeddedExperience = (): boolean => {
  const { embedScope, isEmbedAllowedForOrg } = resolveEmbeddedLaunchContext();
  const { inIframe, cookiesUsable } = detectPartitionCookieSupport();
  return isEmbedAllowedForOrg === true && embedScope != null && inIframe && cookiesUsable;
};

/*
 * Whether the current iframe supports CHIPS cookies. Unlike
 * `isEmbeddedExperience`, this doesn't depend on the LTI launch context.
 */
export const isPartitionedIframeContext = (): boolean => {
  const { inIframe, cookiesUsable } = detectPartitionCookieSupport();
  return inIframe && cookiesUsable;
};
